import { app_psnl_menu_template_sharing_by_login_link_RowClass, app_psnl_menu_template_sharing_by_login_link_RowInterface } from "../../dbschema/app_psnl_menu_template_sharing_by_login_link.model";
import { BaseContainerModel } from "../base-container.model";

export class PersonalMenuTemplateSharingByLoginLinkContainer extends BaseContainerModel {
  app_psnl_menu_template_sharing_by_login_link: app_psnl_menu_template_sharing_by_login_link_RowInterface = new app_psnl_menu_template_sharing_by_login_link_RowClass();
}